module.exports = __webpack_public_path__ + "static/about_slider-4db0974dda992634dcc0d654d7c80240.jpg";